import React, { PropTypes, Component } from 'react';
import ReactDOM from 'react-dom';
import withStyles from '../../decorators/withStyles';
import styles from './UploadBox.css';

@withStyles(styles)
class UploadBox extends Component {
  static propTypes = {
    uploadData: PropTypes.object,
    uploadPath: PropTypes.string,

    submit: PropTypes.func.isRequired,
    change: PropTypes.func
  };

  static defaultProps = {
    change: function() {}
  }

  change(e) {
    var path = e.target.value;
    var data = new FormData();
    data.append('svg', ReactDOM.findDOMNode(this.refs.file).files[0]);

    this.props.change(data, path);
  }

  submit(e) {
    e.preventDefault();
    this.props.submit();
  }

  render() {
    return (
      <div className="UploadBox">
        <form className="form" onSubmit={this.submit.bind(this)} encType="multipart/form-data">
          <div className="form-group col-md-6 no-padding small-right">
            <span className="btn btn-default btn-file btn-block">
              Select<input accept="image/svg+xml,image/png,image/jpeg" ref="file" onChange={this.change.bind(this)} val={this.props.uploadData} type="file" name="svg" />
            </span>
          </div>

          <div className="form-group col-md-6 no-padding small-left">
            <input className="btn btn-primary btn-block" disabled={(this.props.uploadData) ? false : 'disabled'} type="submit" value="Upload" />
          </div>

          {this.props.uploadPath &&
          <div className="col-md-12 no-padding ">
            <div className="form-group has-success has-feedback">
              <input type="text" readOnly="readOnly" value={this.props.uploadPath} className="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status" />
              <span className="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true"></span>
            </div>
          </div>
          }

          {!this.props.uploadPath &&
          <div className="col-md-12 no-padding">
            <p className="help-block">From your computer choose an SVG image you wish to convert.</p>
          </div>
          }

          <div className="clearfix"></div>

        </form>
      </div>
    );
  }
}

export default UploadBox;



/** WEBPACK FOOTER **
 ** ./src/components/UploadBox/UploadBox.js
 **/